module.exports = __webpack_public_path__ + "img/icon-notice.svg";